export default class CareAtWorkLoginModule {
    provides() {
        return {
            'root-routes': [() => require('./index').LoginRootRoutes],
        };
    }
}
